/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AutoApplyCouponsList } from '../../models/auto-apply-coupons-list';

export interface CouponsAutoApplyGet$Params {
  'Active-Tenant-Identifier': string;
}

export function couponsAutoApplyGet(http: HttpClient, rootUrl: string, params: CouponsAutoApplyGet$Params, context?: HttpContext): Observable<StrictHttpResponse<AutoApplyCouponsList>> {
  const rb = new RequestBuilder(rootUrl, couponsAutoApplyGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AutoApplyCouponsList>;
    })
  );
}

couponsAutoApplyGet.PATH = '/coupons/auto-apply';
